import React from "react";
import ReactDOM from "react-dom";
import ReactDOMServer from "react-dom/server";
import "./ArrayExtensions";
import { SpecializationsList } from "../Blocks/SpecializationsList/SpecializationsList";
import { ArticleList } from "./ArticleList/ArticleList";
import { ArticleCategories } from "./ArticleCategories/ArticleCategories";
import { ImageGallery } from "../Blocks/ImageGallery/ImageGallery";
import { CampaignTeasers } from "./CampaignTeasers/CampaignTeasers";
import { FeaturedDoctors } from "./FeaturedDoctors/FeaturedDoctors";
import { BookingButton } from "./BookingButton/BookingButton";
import { ServicesContainer } from "./ServicesContainer/ServicesContainer";
import { DoctorsContainer } from "./DoctorsContainer/DoctorsContainer";
import { PriceList } from "./PriceList/PriceList";
import { Waitlist } from "./Waitlist/Waitlist";
import { EditableWaitlist } from "./Waitlist/EditableWaitlist";
import { MyAppointment } from "./MyAppointment/MyAppointment";
import { Search } from "./Search/Search";
import { Booking } from "./Booking/Booking/Booking";
import { MapContainer } from "./Map/MapContainer";
import { NewsArticleDoctorsContainer } from "./NewsArticle/NewsArticleDoctorsContainer";
import { TopBar } from "../Partials/TopBar/TopBar";
import { CalendarBlock } from "../Blocks/CalendarBlock/CalendarBlock";
import { DoctorHighlightContainer } from "../Blocks/DoctorHighlightContainer/DoctorHighlightContainer";
import { TeaserLinksContainer } from "../Blocks/TeaserLinksContainer/TeaserLinksContainer";
import { TopBar as InsuranceTopBar } from "./Insurance/View/Layout/TopBar";
import { InsuranceHome } from "./Insurance/InsuranceHome";
import { CvUploadForm } from "../Blocks/CvUpload/CvUploadForm";
import { ContactForm } from "../Blocks/ContactForm/ContactForm";
import { InsuranceTreater } from "./Insurance/InsuranceTreater";
import { FavoritesDoctors } from "./Insurance/FavoritesDoctors";
import { InsuranceGenericAppointment } from "./Insurance/InsuranceGenericAppointment";
import { InsuranceContact } from "./Insurance/InsuranceContact";
import { InsuranceError } from "./Insurance/InsuranceError";
import { ServicesNotOffered } from "./ServicesNotOffered/ServicesNotOffered";
import { BaseFeesWithCampaignLegacy } from "./PriceList/BaseFeesWithCampaignLegacy";
import { TopbarBookingButton } from "./BookingButton/TopbarBookingButton";
import { ReportErrorButton } from "./Insurance/View/Layout/ReportError/ReportErrorButton";
import { ImageContent } from "../Blocks/ImageContent/ImageContent";
import { ServicePricing } from "./ServicePricing/ServicePricing";
import { PatientQuotesContainer } from "../Partials/PatientQuotes/PatientQuotesContainer";
import { HeroPriceProvider } from "../Components/HeroPrice/HeroPriceProvider";
import {BookingSearch} from "./BookingSearch/BookingSearch";
import { MyAppointmentLegacy } from "./MyAppointmentLegacy/MyAppointment";

declare const global: any;

declare global {
  interface Window {
    storage: { [key: string]: any };
  }
}

const Components: any = {
  SpecializationsList: SpecializationsList,
  ArticleList: ArticleList,
  ArticleCategories: ArticleCategories,
  BookingButton: BookingButton,
  ImageGallery: ImageGallery,
  CampaignTeasers: CampaignTeasers,
  FeaturedDoctors: FeaturedDoctors,
  ServicesContainer: ServicesContainer,
  DoctorsContainer: DoctorsContainer,
  NewsArticleDoctorsContainer: NewsArticleDoctorsContainer,
  PriceList: PriceList,
  Waitlist: Waitlist,
  EditableWaitlist: EditableWaitlist,
  MyAppointment: MyAppointment,
  MyAppointmentLegacy: MyAppointmentLegacy,
  Search: Search,
  Booking: Booking,
  MapContainer: MapContainer,
  TopBar: TopBar,
  CalendarBlock: CalendarBlock,
  DoctorHighlightContainer: DoctorHighlightContainer,
  TeaserLinksContainer: TeaserLinksContainer,
  InsuranceTopBar: InsuranceTopBar,
  InsuranceHome: InsuranceHome,
  CvUploadForm: CvUploadForm,
  ContactForm: ContactForm,
  InsuranceTreater: InsuranceTreater,
  FavoritesDoctors: FavoritesDoctors,
  InsuranceGenericAppointment: InsuranceGenericAppointment,
  InsuranceContact: InsuranceContact,
  InsuranceError: InsuranceError,
  ServicesNotOffered: ServicesNotOffered,
  BaseFeesWithCampaign: BaseFeesWithCampaignLegacy,
  TopBarBookingButton: TopbarBookingButton,
  ReportErrorButton: ReportErrorButton,
  ImageContent: ImageContent,
  ServicePricing: ServicePricing,
  PatientQuotesContainer: PatientQuotesContainer,
  HeroPriceProvider: HeroPriceProvider,
  BookingSearch: BookingSearch
};

for (const component in Components) {
  global[component] = Components[component];
}

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;
